export const helpDeskLink =
	'https://helpdesk.internal.agilox.net/servicedesk/customer/portal/6/group/34/create/121';
